module.exports = __webpack_public_path__ + "img/img_5.40036265.jpg";